import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * RootRedirect — replaces the former RootLanguageChooser at `/`.
 *
 * Client-side language decision (per official Decision, option C):
 *   1. If localStorage['myguardpod-lang'] is 'fr' or 'en' → use it
 *   2. Else if navigator.language starts with 'fr' → 'fr'
 *   3. Otherwise → 'en'
 *
 * Never applied on /fr, /en or their sub-pages — those paths mount their
 * own components directly and are never routed through this component.
 */
const RootRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let lang = 'en';
    try {
      const stored = typeof window !== 'undefined' && localStorage.getItem('myguardpod-lang');
      if (stored === 'fr' || stored === 'en') {
        lang = stored;
      } else if (typeof navigator !== 'undefined' && navigator.language) {
        if (navigator.language.toLowerCase().startsWith('fr')) lang = 'fr';
      }
    } catch (e) { /* ignore */ }
    navigate(lang === 'fr' ? '/fr' : '/en', { replace: true });
  }, [navigate]);

  // Render nothing — user is redirected on mount.
  return null;
};

export default RootRedirect;
